import { initializeApp as initializeFirebaseApp } from 'firebase/app';
import {
  getAuth as getFirebaseAuth,
  signInWithCustomToken,
  GoogleAuthProvider as firebaseAuthGoogleAuthProvider
} from 'firebase/auth';
import {
  serverTimestamp,
  getDatabase as getFirebaseDatabase,
  ref as getFirebaseDatabaseRef,
  get as getFirebaseDatabaseValue,
  set as setFirebaseDatabaseRef,
  update as updateFirebaseDatabaseRef,
  push as pushFirebaseDatabaseRef,
  remove as removeFirebaseDatabaseRef,
  child as getFirebaseDatabaseChildRef,
  onValue as onFirebaseDatabaseValue,
  onDisconnect as onFirebaseDatabaseDisconnect,
  off as offFirebaseDatabase
} from 'firebase/database';

import { firebaseURL, firebaseApiKey, firebaseAuthDomain, firebaseProjectId } from '../../config';

export const getPrimaryApp = () => initializeFirebaseApp({
  databaseURL: firebaseURL,
  apiKey: firebaseApiKey,
  authDomain: firebaseAuthDomain,
  projectId: firebaseProjectId
});

export const getPrimaryDatabase = () => getFirebaseDatabase(getPrimaryApp());

export const getSecondaryApp = () => initializeFirebaseApp(
  {
    databaseURL: 'https://qs-general-db.firebaseio.com',
    apiKey: firebaseApiKey,
    authDomain: firebaseAuthDomain,
    projectId: firebaseProjectId
  },
  'secondary'
);

export const getSecondaryDatabase = () => getFirebaseDatabase(getSecondaryApp());

export const getDatabaseRef = (path) => getFirebaseDatabaseRef(getPrimaryDatabase(), path);

export const getSecondaryDatabaseRef = (path) =>
  getFirebaseDatabaseRef(getSecondaryDatabase(), path);

export const getDatabaseValue = (ref) => getFirebaseDatabaseValue(ref);

export const setDatabaseRef = (ref, value) => setFirebaseDatabaseRef(ref, value);

export const updateDatabaseRef = (ref, value) => updateFirebaseDatabaseRef(ref, value);

export const pushDatabaseRef = (parentRef, value) => pushFirebaseDatabaseRef(parentRef, value);

export const removeDatabaseRef = (ref) => removeFirebaseDatabaseRef(ref);

export const getDatabaseChildRef = (parentRef, childPath) =>
  getFirebaseDatabaseChildRef(parentRef, childPath);

export const onDatabaseValue = (ref, successCallback = () => {}, errorCallback = () => {}) =>
  onFirebaseDatabaseValue(ref, successCallback, errorCallback);

export const offDatabase = (ref, eventType = 'value', callback = () => {}) =>
  offFirebaseDatabase(ref, eventType, callback);

export const onDatabaseDisconnect = (ref) => onFirebaseDatabaseDisconnect(ref);

export const getServerTimestamp = () => serverTimestamp();

export const getAppAuth = () => getFirebaseAuth(getPrimaryApp());

export const getIdToken = () =>
  getAppAuth().currentUser ? getAppAuth().currentUser.getIdToken() : null;

export const firebaseLogin = ({ token }) => signInWithCustomToken(getAppAuth(), token).then((result) => {
  const { user } = result || {};
  if (!user) {
    // eslint-disable-next-line prefer-promise-reject-errors
    return Promise.reject('No user associated with the token');
  }

  const { displayName, photoURL } = user;

  return user.getIdToken().then((firebaseToken) => {
    const credential = firebaseAuthGoogleAuthProvider.credential(firebaseToken);
    return { credential, displayName, photoURL };
  });
});

export const firebaseLogout = () => getAppAuth().signOut();
